export const documentHeaderOptions = [
  { label: 'Add New Document', value: 'Add New Document', callback: 'onClickAddNewDocument' }
];
